/**
 * Created by sunshine on 2016/12/27.
 */
/*eslint-disable*/
let apiLinks
let enterpriseId = 477
// let domains = 'https://'
// 开发环境 dev http://yc.yonyou.com 92
// 正式环境 https://www.yonyouyc.com 477  https://yc.yonyoucloud.com
let yc = 'https://yc.yonyoucloud.com'
let curlinks = 'http://' + window.location.host
apiLinks = {
  // 查询南方水泥的
  materiaClass: yc + '/yuncai/jsonp/pubmaterialClass?enterpriseId=' + enterpriseId,
  // 南方水泥各链接
  southCement: {
    home: 'http://www.scement.cn/cn/'
  },
  caslogout: yc + '/yuncai/caslogout/all?logouturl=' + window.location.host + '/caslogout',
  // 注册页面
  register: yc + '/yuncai/privateportal#/pages/supplymgr/supplyapplyregister?purentid=' + enterpriseId + '&agree=1&ipuid=nfsn',
  // 进入工作台/注册
  enterWorkbench: yc + '/yuncai/pubportal/redirect2workbench.html?ipuid=nfsn&redirectsrc=' + curlinks,
  // 供应商申请
  suppliersFor: yc + '/yuncai/SSO/registerredirect.html?v='+Date.parse(new Date().toLocaleDateString()),
  // 首页左侧数据相关链接
  infoTable: {
    latest: [
      yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6',
      'latest2',
      'latest3'
    ],
    area: [
      yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6',
      'area2',
      'area3',
      'area4',
      'area5',
      'area6',
      'area7',
      'area8'
    ],
    type: [
      yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allNotice&supEnterpriseIds=' + enterpriseId + '&status=4&pageIndex=0&pageSize=6',
      '2',
      '3',
      '4'
    ]
  },
  // 物资招标公告链接(之后封装成一个对象目前只有两个)
  purchasetableDate: [
    // 询价公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=0&pageSize=10&pageIndex=0',
    // 招标公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=4&pageSize=10&pageIndex=0',
    // 中标公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=purchase&supEnterpriseIds=' + enterpriseId + '&status=5&pageSize=10&pageIndex=0',
  ],
  // 物流招标公告链接
  logisticstableDate: [
    // 询价公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=0&pageSize=10&pageIndex=0',
    // 招标公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=6&pageSize=10&pageIndex=0',
    // 中标公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=logistics&supEnterpriseIds=' + enterpriseId + '&status=7&pageSize=10&pageIndex=0',
  ],
  // 竞买竞卖公告链接
  dealtableDate: [
    // 竞价公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=bidauction&supEnterpriseIds=' + enterpriseId + '&status=15&pageSize=10&pageIndex=0',
    // 中标公告
    yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=bidauction&supEnterpriseIds=' + enterpriseId + '&status=17&pageSize=10&pageIndex=0',
  ],
  // 查看详情不同status跳转页面 bidDetails: cpu-fe-bid -> cpu-fe-tender
  details: {
    bidDoc: yc + '/cpu-fe-bid/dist/bidddocread/index.html?type=1&id=',
    bidDetails: yc + '/cpu-fe-tender/dist/supplyenlistshowother/index.html?show=1&id=',
    bidNotice: yc + '/cpu-fe-bid/dist/submitbidnotice/index.html?type=3&id=',
    bidMsg: yc + '/cpu-fe-bid/dist/submitbidnotice/index.html?type=3&id=',
    inquiryDetails: yc + '/cpu-fe-tender/dist/inquirydetail/index.html?id=',
    jingjia: yc + '/cpu-bidauction-fe/bidding_Apply/index.zh_CN.html?id=',
    company: yc + '/gwmanage/pages/notice/detail.html?id=',
    bidauctionNotice: yc + '/cpu-bidauction-fe/bidNotificationPublic/index.zh_CN.html?id=',
  },
  // 首页右侧数据相关链接
  notice: {
    company: yc + '/yuncai/jsonp/entnotice?appcode=cpu&tenantid=eci0x4ex&pageSize=6',
    bidding: yc + '/yuncai/jsonp/supplierOffer/list?type=pp&bidType=allBidNotice&supEnterpriseIds=' + enterpriseId + '&status=5&pageIndex=0&pageSize=6',
    clarify: ''
  },
  // 联系我们页面
  contact: yc + '/cpu-project-def/ycctrl/projectdef/getBidCountInfo?enterpriseId=' + enterpriseId
}
export {apiLinks}



// WEBPACK FOOTER //
// ./src/api/links.js